import requests from './httpService';

const AppVersionService = {
  get() {
    return requests.get('/app-version');
  },
  create(body) {
    return requests.post('/app-version', body);
  },
  update(body) {
    return requests.put('/app-version', body);
  },
};

export default AppVersionService;
